import store from "@/store";

const routes = [{
    path: "/operations/warehouse-user/:id",
    name: "warehouseuser",
    component: () => import('@/views/main/modules/Operations/WarehouseUser/WarehouseUserGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Warehouse Users'
    }
}]

export default routes;
